import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import PatientFlow from 'components/Flows/PatientFlows/PatientFlows';
import PatientAnalysisDrawer from 'components/Analyses/PatientAnalyses/Drawer/Drawer';

const PatientFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <PatientAnalysisDrawer />
      <PatientFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <PatientFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);